import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './PackVerification.frontend.types'

@Injectable({ providedIn: 'root' })
export class PackVerification_validate_shipping_container_contents_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { startPackVerificationTaskId: number, canSubstituteSerials?: boolean }): Promise<{ reasons?: string[], isValid?: boolean }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.startPackVerificationTaskId)) {
      missingRequiredInParams.push('\'startPackVerificationTaskId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PackVerification/functions/validate_shipping_container_contents_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

